import React, { useEffect, useState } from 'react';
import { func, number, object } from 'prop-types';

import { Box, Grid } from '@material-ui/core';

import { useError } from '@avon/component-library';
import Typography from '@avon/component-library/dist/Typography/Typography';

import { makeStyles } from '@material-ui/styles';
import { getHelpSupportInfo } from '../../utils/api/endpoints';

import foldSvg from '../../styles/assets/fold_arrow.svg';
import { isMobile, isDesktop } from '../../utils/getDeviceType';

const useStyles = makeStyles(() => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const Help = ({ callApi }) => {
  const classes = useStyles();

  const { setError, cleanToastBanner } = useError();

  const [title, setTitle] = useState('Help & Support');
  const [faqs, setFaqs] = useState([]);
  const [current, setCurrent] = useState();
  const [collapse, setCollapse] = useState(true);

  useEffect(() => {
    const getContent = async () => {
      try {
        // get help & support content
        await callApi(getHelpSupportInfo()).then((res) => {
          setTitle(res.jsonObject.helpSupportInfo.header);
          setFaqs(res.jsonObject.helpSupportInfo.faqs);
        });

        cleanToastBanner();
        return true;
      } catch (e) {
        setError(e.error);
        return false;
      }
    };

    getContent();
  }, []);

  const Row = ({ faq, index }) => {
    const { faqQuestion, faqAnswer } = faq;
    return (
      <Box style={{ margin: isMobile() ? '12px 16px 0' : '0 24px 6px', border: '1px solid #e4eded' }}>
        <Box
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          onClick={() => {
            if (index !== current) {
              setCurrent(index);
              setCollapse(false);
            } else {
              setCollapse(!collapse);
            }
          }}
        >
          <Typography
            weight={isMobile() ? 'bold' : 'medium'}
            style={{
              margin: 18,
              flexGrow: 1,
              fontWeight: 500,
              fontSize: 16,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              webkitLineClamp: '2',
              webkitBoxOrient: 'vertical',
              display: index === current && !collapse ? 'block' : '-webkit-box',
            }}
          >
            {faqQuestion}
          </Typography>
          <Box style={{ margin: 18 }}>
            <img
              alt="arrow-fold"
              src={foldSvg}
              style={{ transform: index === current && !collapse ? 'rotateZ(180deg)' : '' }}
            />
          </Box>
        </Box>
        <Box style={{ display: index === current && !collapse ? 'block' : 'none', borderTop: '1px solid #e4eded' }}>
          <Box style={{ margin: '12px 18px 18px 18px' }}>
            <Typography variant="body2" style={{ fontSize: isMobile() ? 14 : 16, lineHeight: isMobile() ? '20px' : '24px' }}>{faqAnswer}</Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  Row.propTypes = {
    faq: object.isRequired,
    index: number.isRequired,
  };

  return (
    <Box className={classes.main}>
      <Grid style={{ marginTop: 12 }}>
        <Typography
          variant={isMobile() ? 'h3' : 'h4'}
          style={{
            margin: isDesktop() ? '24px 48px' : '24px',
            fontSize: '24px',
            fontFamily: 'Montserrat-Medium',
          }}
        >
          {title}
        </Typography>
      </Grid>
      <Grid>
        {faqs.map((faq, index) => <Row key={`faq-${index}`} faq={faq} index={index} />)}
      </Grid>
    </Box>
  );
};

Help.propTypes = {
  callApi: func.isRequired,
};

export default Help;
